import { render, staticRenderFns } from "./Heatmap.vue?vue&type=template&id=70d60ace&scoped=true&"
import script from "./Heatmap.vue?vue&type=script&lang=js&"
export * from "./Heatmap.vue?vue&type=script&lang=js&"
import style0 from "./Heatmap.vue?vue&type=style&index=0&id=70d60ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d60ace",
  null
  
)

export default component.exports